const size = {
    title:'.2rem',
    text: '.16rem',
    small:'.14rem',
    large: '.3rem'
};
export default size;
